<template>
    <div>
      <b-alert variant="success" :show="showAlert_success" @dismissed="showAlert_success = false">{{ alert_success_message
      }}</b-alert>
      <b-container fluid>
        <b-breadcrumb class="mt-3 mb-3" :items="breadcrumb_items" />
  
        <b-card class="mb-1">
          <b-form-group id="grp_txt_region" label="Case Region:" label-for="txt_region" label-size="sm">
            <b-form-select size="sm" v-model="tracking_return_handling_obj.region" :options="region_options" />
          </b-form-group>
  
          <b-form-group id="grp_txt_region" label="Case Category:" label-for="txt_category" label-size="sm">
            <b-form-select size="sm" v-model="tracking_return_handling_obj.category" :options="category_options" />
          </b-form-group>
  
          <b-form-group id="grp_txt_tracking_number" label="Order Number:" label-for="txt_tracking_number" label-size="sm">
            <b-form-input id="txt_tracking_number" type="text" required placeholder
              v-model="tracking_return_handling_obj.tracking_number"></b-form-input>
          </b-form-group>
  
          <b-form-group id="grp_txt_content" label="Message:" label-for="txt_content" label-size="sm">
            <b-form-textarea id="txt_content" v-model="tracking_return_handling_obj.content" required placeholder rows="3"
              max-rows="6"></b-form-textarea>
          </b-form-group>
  
          <div class="col-form-label col-form-label-sm pt-0" v-show="false">
            Product Info:
          </div>
  
          <b-row v-show="false" class="mb-2" :key="row_product_i" v-for="(row_product, row_product_i) in row_products_f">
            <b-col class="pr-1">
              <b-form-input size="sm" :id="'txt_product_number_' + row_product_i" type="text" placeholder="Product #"
                v-model="row_product.product_number" @change="lookupProduct(row_product, row_product_i)"></b-form-input>
            </b-col>
  
            <b-col class="pl-0 pr-1">
              <b-form-input size="sm" :id="'txt_description_' + row_product_i" type="text" placeholder="Description"
                v-model="row_product.description" disabled></b-form-input>
            </b-col>
  
            <b-col class="pl-0 pr-1">
              <b-form-input size="sm" :id="'txt_lot_number_' + row_product_i" type="text" placeholder="Lot #"
                v-model="row_product.lot_number"></b-form-input>
            </b-col>
  
            <b-col class="pl-0 pr-1">
              <b-form-input size="sm" :id="'txt_price_' + row_product_i" type="text" placeholder="Unit Price"
                v-model="row_product.price" disabled></b-form-input>
            </b-col>
  
            <b-col class="pl-0 pr-1">
              <b-form-input size="sm" :id="'txt_quantity_' + row_product_i" type="text" placeholder="Quantity"
                v-model="row_product.quantity"></b-form-input>
            </b-col>
  
            <b-col class="pl-0 pr-1">
              <b-form-input size="sm" :id="'txt_total_amount_' + row_product_i" type="text" placeholder="Total Amount"
                v-model="row_product.total_amount" disabled></b-form-input>
            </b-col>
            <b-col class="pl-0">
              <b-button type="button" size="sm" variant="primary" @click="calculateAmt()">
                Calculate
              </b-button>
            </b-col>
          </b-row>
  
          <b-button class="float-right" type="submit" variant="primary" @click="createCSIssue()">Submit</b-button>
        </b-card>
      </b-container>
    </div>
  </template>
  
  <script>
  import moment from "moment";
  import VueBarcode from "vue-barcode";
  
  export default {
    name: "TrackingReturnHandlingAdd",
    inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT"],
    components: {},
    data() {
      return {
        region_options: [
          {
            value: "Hong Kong",
            text: "Hong Kong"
          },
          {
            value: "Macau",
            text: "Macau"
          }
        ],
        category_options: [
          {
            value: "Damage - Product Damage",
            text: "Damage - Product Damage"
          },
          {
            value: "Delivery - Late (Specified Timeframe)",
            text: "Delivery - Late (Specified Timeframe)"
          },
          {
            value: "Delivery - Late (Standard Timeframe)",
            text: "Delivery - Late (Standard Timeframe)"
          },
          {
            value: "Delivery - Other Service Issues",
            text: "Delivery - Other Service Issues"
          },
        ],
        breadcrumb_items: [
          {
            text: "Tracking Return Handling",
            to: { name: "tracking_return_handlings" }
          },
          {
            text: "Create",
            active: true
          }
        ],
        tracking_return_handling_obj_org: {
          region: "Hong Kong",
          tracking_number: "",
          category: "Warehouse - Product Damage/Defective",
          content: ""
        },
        tracking_return_handling_obj: {
          region: "Hong Kong",
          tracking_number: "",
          category: "Warehouse - Product Damage/Defective",
          content: ""
        },
        loader: false,
        items: [],
        currentPage: 1,
        table_offset: 0,
        total_rows: 0,
        search_criteria: {
          keyword: "",
          status_selected: null
        },
        showAlert_success: false,
        alert_success_message: "",
        user_id: false,
  
        default_product: {
          product_number: "",
          lot_number: "",
          quantity: "",
          price: "",
          total_amount: "",
          description: ""
        },
  
        row_products: []
      };
    },
    async created() {
      if (this.$route.params.tracking_return_handling_id) {
        await this.getCsIssue();
      }
      if (this.$route.params.tracking_id) {
        await this.getTracking();
      }
  
      this.row_products.push(JSON.parse(JSON.stringify(this.default_product)));
      this.row_products.push(JSON.parse(JSON.stringify(this.default_product)));
      this.row_products.push(JSON.parse(JSON.stringify(this.default_product)));
      this.row_products.push(JSON.parse(JSON.stringify(this.default_product)));
      this.row_products.push(JSON.parse(JSON.stringify(this.default_product)));
  
      this.initialized = true;
    },
    mounted() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });
      this.loader.hide();
    },
    computed: {
      row_products_f() {
        console.log(this.row_products);
        let records = [];
        for (let i in this.row_products) {
          let tmp_p = this.row_products[i];
          if (tmp_p.price && tmp_p.quantity) {
            // check if it is fractions
            let qty_cal = tmp_p.quantity;
            if (tmp_p.quantity.includes("/")) {
              let fraction_chk = /[1-9][0-9]*\/[1-9][0-9]*/g;
              if (fraction_chk.exec(tmp_p.quantity)) {
                console.log("it is fractions");
                qty_cal = eval(tmp_p.quantity);
                qty_cal = parseFloat(qty_cal).toFixed(5);
              } else {
                qty_cal = 0;
              }
            }
            console.log(qty_cal);
  
            let tmp_total = parseFloat(tmp_p.price) * parseFloat(qty_cal);
            tmp_total = parseFloat(tmp_total).toFixed(5);
            tmp_total = parseFloat(tmp_total);
            tmp_p.total_amount = tmp_total;
          }
          records.push(tmp_p);
        }
        console.log(records);
        return records;
      }
    },
    methods: {
      displayDate(d) {
        if (d) {
          return moment(d).format("YYYY-MM-DD");
        } else {
          return "/";
        }
      },
  
      async getCsIssue() {
        let response = await this.$http({
          method: "POST",
          baseURL: `${this.API_HOST}`,
          url: "tracking_return_handling_get.php",
          data: {
            tracking_return_handling_id: this.$route.params.tracking_return_handling_id
          }
        });
  
        this.tracking_return_handling_obj_org = JSON.parse(
          JSON.stringify(response.data.trackings[0])
        );
        this.tracking_return_handling_obj = response.data.trackings[0];
  
        this.loader.hide();
      },
  
      submitForm() {
        this.updateTracking(this.tracking);
      },
  
      async getTracking() {
        let response = await this.$http({
          method: "POST",
          baseURL: `${this.API_HOST}`,
          url: "tracking_get.php",
          data: {
            tracking_id: this.$route.params.tracking_id
          }
        });
  
        this.change_request_obj_org = JSON.parse(
          JSON.stringify(response.data.trackings[0])
        );
        this.tracking_return_handling_obj.tracking_number = this.change_request_obj_org.tracking_number;
      },
  
      async createCSIssue() {
        let response = await this.$http({
          method: "POST",
          baseURL: `${this.API_HOST}`,
          url: "tracking_return_handling_add.php",
          data: {
            tracking_return_handling_id: this.$route.params.tracking_return_handling_id,
            region: this.tracking_return_handling_obj.region,
            tracking_number: this.tracking_return_handling_obj.tracking_number,
            category: this.tracking_return_handling_obj.category,
            content: this.tracking_return_handling_obj.content,
            products: this.row_products,
            user_id: this.$store.state.user_obj.user_id,
            client_id: this.$store.state.user_obj.client_id,
          }
        });
  
        if (response.data.status == "success") {
          this.alert_success_message = `CS Issue Created Successfully.`;
          this.showAlert_success = true;
          setTimeout(() => {
            this.showAlert_success = false;
            this.alert_success_message = "";
          }, 3000);
          this.$router.go(-1);
        } else {
        }
      },
  
      async lookupProduct(row_product, row_product_i) {
        console.log("lookupProduct...");
        let response = await this.$http({
          method: "POST",
          baseURL: `${this.API_HOST}`,
          url: "tracking_return_handling_product_lookup.php",
          data: {
            tracking_return_handling_id: this.$route.params.tracking_return_handling_id,
            product_code: row_product.product_number,
            user_id: this.$store.state.user_obj.user_id
          }
        });
  
        if (response.data.status == "success") {
          this.row_products[row_product_i].price = response.data.product.price;
          this.row_products[row_product_i].description =
            response.data.product.item_description;
        } else {
          this.row_products[row_product_i].price = "";
          this.row_products[row_product_i].description = "";
        }
      }
    }
  };
  </script>
  
  <style>
  th,
  td {
    white-space: nowrap;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/TrackingReturnHandlingAdd.vue